module.exports = __webpack_public_path__ + "img/Logo.553a6e58.png";